import axios from 'axios'

export const AuthApi = {
    async Login(data){
        const response = await axios.post('/api/auth/login',data)
        return response
    },
    // Customer Auth endpoints
    async CustomerLogin(data){
        const response = await axios.post('/api/customer-auth/login',data)
        return response
    },
    async SendCustomerOtp(data){
        const response = await axios.post('/api/customer-auth/send-otp',data)
        return response
    },
    async VerifyCustomerOtp(data){
        const response = await axios.post('/api/customer-auth/verify-otp',data)
        return response
    },
    async GetCustomerAccountDetail(customerCode){
        const response = await axios.get(`/api/customer-auth/customer-account-detail/${customerCode}`)
        return response
    },
    async SetCustomerPassword(data){
        const response = await axios.post('/api/customer-auth/set-password',data)
        return response
    },
}